import {http} from "../config/Constantes";

export default class DepartamentoService {
    constructor() {}

    list() {
        return http.get("/departamento");
    }

    listByPrefixoNome(nome) {
        return http.get(`/departamento/prefixo/${encodeURIComponent(nome)}`);
    }
}
